const FlechaIzquierdaIcon = ({ color }) => {
  return (
    <svg
      width="9"
      height="15"
      viewBox="0 0 9 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 13.5L1.76478 8.20595C1.34744 7.82071 1.33435 7.16565 1.73596 6.76404L7.5 1"
        stroke={color ? color : "#006299"}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default FlechaIzquierdaIcon;
